import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormControlService } from 'src/app/shared/services/form-control.service';
import { AlbaranService } from '../../../services/albaran.service';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ConfigurationService } from 'src/app/core';

@Component({
  selector: 'ticketing-buscador-albaran',
  templateUrl: './buscador-albaran.component.html',
  styleUrls: ['./buscador-albaran.component.scss']
})
export class BuscadorAlbaranComponent implements OnInit {
  busquedaAlbaranForm: FormGroup;
  newQuery = '';
  filtrarCentro;
  constructor(
    private formBuilder: FormBuilder,
    private formControlService: FormControlService,
    private albaranService: AlbaranService,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    this.filtrarCentro = this.configurationService.appConfig.value && this.configurationService.appConfig.value.DatosResult.AppConfigJsonVentaGestionar.FiltrarCentro && this.configurationService.appConfig.value.DatosResult.AppConfigJsonVentaGestionar.FiltrarCentro > 0? true:false
    this.busquedaAlbaranForm = this.formBuilder.group({
      tpvId: '',
      query: '',
      filtrarCentro: this.filtrarCentro
    });
    this.albaranService
      .buscar(this.busquedaAlbaranForm.valueChanges)
      .subscribe();
    // this.albaranService.albaran.subscribe( albaran => {
    //   if (albaran && !albaran.noData) {
    //     this.busquedaAlbaranForm.get('query').setValue(albaran.NumAlbaran, {onlySelf: true, emitEvent: false});
    //   } else {
    //     this.busquedaAlbaranForm.get('query').setValue(this.newQuery, {onlySelf: true, emitEvent: false});
    //   }
    // });
  }

  focusValue(event: Event) {
    const target = event.target as HTMLInputElement;
    const category = target.getAttribute('category');
    
    this.formControlService.setCurrentFormGroup(
      this.busquedaAlbaranForm,
      target,
      category
    );
  }

  onMovimiento(event) {
    
    if (this.busquedaAlbaranForm.get('query').value === '') {
      // Verificar que albaranValue existe y tiene NumAlbaran válido
      if (this.albaranService.albaranValue && this.albaranService.albaranValue.NumAlbaran) {
        const queryNumAlbaran =
          +this.albaranService.albaranValue.NumAlbaran + event;
        
        // NO actualizar el campo visual, solo buscar el albarán
        // Crear el objeto con la estructura correcta para buscar2
        const searchParams = {
          value: queryNumAlbaran,
          filtrarCentro: this.busquedaAlbaranForm.get('filtrarCentro').value
        };
        
        this.albaranService.buscar2(of(searchParams)).subscribe();
      } else {
        // Si no hay albarán cargado, no hacer nada o mostrar mensaje
        console.warn('No hay albarán cargado para navegar');
        return;
      }
      return;
    }
    if (
      !Number.isNaN(
        Number.parseInt(this.busquedaAlbaranForm.get('query').value, 10)
      )
    ) {
      this.newQuery =
        '' +
        (Number.parseInt(this.busquedaAlbaranForm.get('query').value, 10) +
          event);
      this.busquedaAlbaranForm.get('query').setValue(this.newQuery);
    } else {
      this.busquedaAlbaranForm.get('query').setValue('');
    }
  }

  isSelected(element) {
    return this.formControlService.currentFormGroupValue &&
    this.formControlService.currentFormGroupValue.elemento &&
      element.id === this.formControlService.currentFormGroupValue.elemento.id
      ? true
      : false;
  }
  changefiltrarCentro(){
    this.filtrarCentro = !this.filtrarCentro;
    // Actualizar el valor en el formulario para que se refleje en las búsquedas
    this.busquedaAlbaranForm.get('filtrarCentro').setValue(this.filtrarCentro);
  }
  mostrarFiltro(){
    return this.configurationService.appConfig.value && this.configurationService.appConfig.value.DatosResult.AppConfigJsonVentaGestionar.FiltrarCentro && this.configurationService.appConfig.value.DatosResult.AppConfigJsonVentaGestionar.FiltrarCentro == 2;
  }

  claseConFiltro(){
    if(this.mostrarFiltro()){
      return 'inputControl control-div-buscador conFiltro'
    }
    return 'inputControl control-div-buscador'
  }
}
